var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "message-custom"
  }, [_c('div', {
    staticClass: "custom"
  }, [_vm.payload.src === _vm.CUSTOM_MESSAGE_SRC.BRANCH || _vm.payload.src === _vm.CUSTOM_MESSAGE_SRC.BRANCH_NUMBER || _vm.payload.src === _vm.CUSTOM_MESSAGE_SRC.ROBOT_MSG && _vm.payload.subtype !== 'welcome_msg' ? _c('div', [_c('MessageBranch', {
    attrs: {
      "payload": _vm.payload
    },
    on: {
      "sendMessage": _vm.sendTextMessage,
      "heightChanged": _vm.onHeightChanged
    }
  })], 1) : _vm._e(), _vm.payload.src === _vm.CUSTOM_MESSAGE_SRC.ROBOT_MSG && _vm.payload.subtype === 'welcome_msg' ? _c('div', [_c('MessageIMRobotWelcome', {
    attrs: {
      "payload": _vm.payload
    },
    on: {
      "sendMessage": _vm.sendTextMessage
    }
  })], 1) : _vm._e(), _vm.payload.src === _vm.CUSTOM_MESSAGE_SRC.FROM_INPUT ? _c('div', [_c('MessageForm', {
    attrs: {
      "payload": _vm.payload
    },
    on: {
      "sendMessage": _vm.sendTextMessage
    }
  })], 1) : _vm._e(), _vm.payload.src === _vm.CUSTOM_MESSAGE_SRC.PRODUCT_CARD ? _c('div', [_c('MessageProductCard', {
    attrs: {
      "payload": _vm.payload
    }
  })], 1) : _vm._e(), _vm.payload.src === _vm.CUSTOM_MESSAGE_SRC.RICH_TEXT ? _c('div', [_c('MessageRichText', {
    attrs: {
      "payload": _vm.payload
    },
    on: {
      "heightChanged": _vm.onHeightChanged,
      "previewImage": _vm.onPreviewImage
    }
  })], 1) : _vm._e(), _vm.payload.src === _vm.CUSTOM_MESSAGE_SRC.STREAM_TEXT ? _c('div', [_c('MessageStream', {
    attrs: {
      "payload": _vm.payload
    },
    on: {
      "heightChanged": _vm.onHeightChanged,
      "previewImage": _vm.onPreviewImage
    }
  })], 1) : _vm._e(), _vm.payload.src === _vm.CUSTOM_MESSAGE_SRC.MULTI_BRANCH ? _c('div', [_c('MessageMultiBranch', {
    attrs: {
      "payload": _vm.payload
    },
    on: {
      "sendMessage": _vm.sendTextMessage,
      "heightChanged": _vm.onHeightChanged
    }
  })], 1) : _vm._e(), _vm.payload.src === _vm.CUSTOM_MESSAGE_SRC.MULTI_FORM && _vm.message.flow == 'in' ? _c('div', [_c('MessageMultiForm', {
    attrs: {
      "payload": _vm.payload
    },
    on: {
      "sendMessage": _vm.sendCustomMessage,
      "showFormPopup": _vm.handleShowFormPopup
    }
  })], 1) : _vm._e(), _vm.payload.src === _vm.CUSTOM_MESSAGE_SRC.MENU ? _c('div', [_c('MessageRating', {
    attrs: {
      "message": _vm.props.message
    },
    on: {
      "sendMessage": _vm.sendCustomMessage
    }
  })], 1) : _vm._e(), _vm.payload.src === _vm.CUSTOM_MESSAGE_SRC.CONCURRENCY_LIMIT ? _c('div', [_c('MessageConcurrencyLimit')], 1) : _vm._e(), _vm.payload.src === _vm.CUSTOM_MESSAGE_SRC.ORDER ? _c('div', [_c('MessageOrder', {
    attrs: {
      "payload": _vm.payload
    }
  })], 1) : _vm._e(), _vm.payload.src === _vm.CUSTOM_MESSAGE_SRC.TRANSFER_TO_HUMAN || _vm.payload.src === _vm.CUSTOM_MESSAGE_SRC.TRANSFER_TO_TASK_FLOW ? _c('div', [_c('MessageTransferWithDesc', {
    attrs: {
      "payload": _vm.payload
    }
  })], 1) : _vm._e(), _vm.payload.src === _vm.CUSTOM_MESSAGE_SRC.QUEUE_CONFIRMATION ? _c('div', [_c('MessageQueueConfirmation', {
    attrs: {
      "payload": _vm.payload
    },
    on: {
      "sendMessage": _vm.sendCustomMessage
    }
  })], 1) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }